import { ApiTask, TaskStatus, TaskType } from "griptonite-api-client/types/tasks";

// Drag and drop data is untyped at runtime, so each shape carries its own
// symbol key for the type guards below to check.
type DragData = Record<string | symbol, unknown>;

const taskKey = Symbol("task");
const gradeRowKey = Symbol("gradeRow");
const statusColumnKey = Symbol("statusColumn");

export type TaskDragData = { [taskKey]: true; task: ApiTask };

export const getTaskDragData = (task: ApiTask): TaskDragData => ({
  [taskKey]: true,
  task,
});

export const isTaskDragData = (data: DragData): data is TaskDragData => data[taskKey] === true;

export type GradeRowDropData = {
  [gradeRowKey]: true;
  type: TaskType;
  gradeSystem: string;
  gradeValue: string | null;
};

export const getGradeRowDropData = (
  data: Omit<GradeRowDropData, typeof gradeRowKey>,
): GradeRowDropData => ({ [gradeRowKey]: true, ...data });

export const isGradeRowDropData = (data: DragData): data is GradeRowDropData =>
  data[gradeRowKey] === true;

export type StatusColumnDropData = {
  [statusColumnKey]: true;
  type: TaskType;
  status: TaskStatus;
};

export const getStatusColumnDropData = (
  data: Omit<StatusColumnDropData, typeof statusColumnKey>,
): StatusColumnDropData => ({ [statusColumnKey]: true, ...data });

export const isStatusColumnDropData = (data: DragData): data is StatusColumnDropData =>
  data[statusColumnKey] === true;
